export default __webpack_public_path__ + "files/64.8f8b5c44a0bf8d1ce95ddf4ddb4abfa1.png";